import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import '../scss/app.scss';
import '../images/index';
import '../favicons/index';
import '../js/nav';
import 'common/js/notifications';
import 'common/rollbar';
import 'common/js/modal_controller/initialize_html_modals';
import 'common/js/promotional_banner';
import '../js/accordion-toggle-all-button';
import '../js/formie-form';
import '../js/breadcrumbs';

window.Offcanvas = Offcanvas;
window.BsModal = Modal;
